module.exports = __webpack_public_path__ + "img/alert.df2f41fa.png";